const $blockForms = $('.form-block form');
const $ctaForms = $('.cta-cards form');

if($blockForms.length > 0) {
  setConsentLink($blockForms);
}

if($ctaForms.length > 0) {
  setConsentLink($ctaForms);
}

if($blockForms.length > 0 || $ctaForms.length > 0) {
  fillField('gclid', getUrlParam('gclid'));
  fillField('fbclid', getUrlParam('fbclid'));
  fillField('utm_source', getUrlParam('utm_source'));
  fillField('utm_medium', getUrlParam('utm_medium'));
  fillField('utm_campaign', getUrlParam('utm_campaign'));
  fillField('utm_content', getUrlParam('utm_content'));
  fillField('utm_term', getUrlParam('utm_term'));
  fillField('msclkid', getUrlParam('msclkid'));
  fillField('li_fat_id', getUrlParam('li_fat_id'));
  fillField('landing_page', getUrlParam('landing_page'));
  fillField('referrer', getUrlParam('referrer'));
}

function setConsentLink($forms) {
  $forms.each(function() {
    if($(this).find('input[data-name="privacy_policy"]').length > 0 && $(this).find('input[data-name="privacy_policy"] + span label').length > 0) {
      let $text = $(this).find('input[data-name="privacy_policy"] + span label').text();
      $text = $text.replace('Integritetspolicy', '<a href="https://upheads.se/upheads-integritets-och-persondatapolicy" target="_blank">Integritetspolicy</a> ');
      $(this).find('input[data-name="privacy_policy"] + span label').html($text);
    }
  });
}

function getUrlParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name) || '';
}

function fillField(fieldName, value) {
  const fields = document.querySelectorAll(
    `input[name="${fieldName}"], input[id="${fieldName}"]`
  );
  if (fields.length === 0 || !value) return; // exit if field doesn't exist or no value
  fields.forEach(el => el.value = value);
}